var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component, Watch } from 'vue-property-decorator';
import RootType from '../../store/mutation-types';
import SystemSettingsService from '../../api/SystemSettingsService';
import DeliverySplitRuleDialog from './components/DeliverySplitRuleDialog.vue';
import DeliverySpotPurchaseRuleDialog from './components/DeliverySpotPurchaseRuleDialog.vue';
var Index = (function (_super) {
    __extends(Index, _super);
    function Index() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.systemSetting = {
            document: {},
            edi_status: '0',
            is_delivery_expired_goods: '',
            is_delivery_will_expired_goods: '',
            is_delivery_manual_batch: '',
            is_send_purchase_mail: '',
            is_erp: '',
            is_sorting: '',
            is_purchase: '',
            is_multi_organ: '',
            is_show_erp: '',
            is_show_purchase: '',
            is_show_sorting: '',
            is_show_multi_organ: '',
            franchisee: {
                is_open_franchisee: '',
                is_non_franchisee_order: '',
                is_expire_franchisee_order: '',
                warning_remain_day: 30,
            },
            delivery_is_goods_price_to_no_price: '',
            delivery_is_auto_add_goods_price_to_no_price: '',
            business_data_power_status: '',
            depot_data_power_status: '',
            permission_change_notify_status: 1,
            open_auto_split_delivery_order: 0,
            auto_split_delivery_order: 0,
            auto_split_delivery_order_rule_type: 1,
            auto_split_delivery_order_rule_goods_type: 1,
            auto_split_delivery_order_rule_type_value: 1,
            sale_report_auto_return_order: 0,
            sale_report_un_confirm_order: 1,
            sale_report_un_sign_order: 0,
            auto_create_statement_order: 0,
            auto_create_statement_order_config: {
                type: 1,
                value: 1,
            },
            is_have_scm_business: 0,
            ap_account_type: 0,
            supplier_version: 1,
            business_data_power_use: 1,
            account_performance_power: 1,
            upper_warehouse_order_rule: 2,
            upper_warehouse_order_rule_count: 0,
            upper_warehouse_order_rule_type: 1
        };
        _this.basicSettingOpen = true;
        _this.liceseSettingOpen = true;
        _this.depotPowerOpen = true;
        _this.notifyOpen = true;
        _this.goods_type_options = [
            {
                id: 1,
                label: '一级',
            },
            {
                id: 2,
                label: '二级',
            },
            {
                id: 3,
                label: '三级',
            },
        ];
        return _this;
    }
    Index.prototype.handleDeliverPriceOpen = function (newValue, oldValue) {
        if (newValue == 2) {
            this.systemSetting.delivery_is_auto_add_goods_price_to_no_price = 2;
        }
    };
    Index.prototype.created = function () {
        this.service = SystemSettingsService.getInstance();
    };
    Index.prototype.mounted = function () {
        this.getSupplierConfigdetail();
    };
    Index.prototype.collapse = function (type) {
        if (type == 1) {
            this.basicSettingOpen = !this.basicSettingOpen;
        }
        else if (type == 2) {
            this.liceseSettingOpen = !this.liceseSettingOpen;
        }
        else if (type == 3) {
            this.depotPowerOpen = !this.depotPowerOpen;
        }
        else if (type == 4) {
            this.notifyOpen = !this.notifyOpen;
        }
    };
    Index.prototype.getSupplierConfigdetail = function () {
        var _this = this;
        this.service
            .getSupplierConfigdetail({})
            .then(function (res) {
            if (res.data && res.data.success) {
                _this.systemSetting = Object.assign(_this.systemSetting, res.data.data);
                _this.systemSetting.edi_status =
                    _this.systemSetting && _this.systemSetting.edi_status ? _this.systemSetting.edi_status : '0';
                _this.$store.commit(RootType.UPDATE_EDI_STATUS, _this.systemSetting.edi_status == 1 ? true : false);
                _this.$store.commit(RootType.UPDATE_IS_ERP, _this.systemSetting.is_erp);
                _this.systemSetting.auto_split_delivery_order_rule_type = _this.systemSetting.auto_split_delivery_order_rule.type;
                _this.systemSetting.auto_split_delivery_order_rule_goods_type = _this.systemSetting.auto_split_delivery_order_rule.goods_type;
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Index.prototype.save = function () {
        var _this = this;
        if (this.systemSetting.franchisee.is_open_franchisee) {
            var reg = /^[1-9]\d*$/;
            if (!reg.test(this.systemSetting.franchisee.warning_remain_day)) {
                this.$message.error('加盟预警提示时间输入正整数!');
                return;
            }
            this.systemSetting.franchisee.warning_remain_day = Number(this.systemSetting.franchisee.warning_remain_day);
        }
        if (this.systemSetting.auto_create_statement_order == 1 &&
            this.systemSetting.auto_create_statement_order_config.type == 1) {
            var reg = /^[1-9]\d*$/;
            if (!reg.test(this.systemSetting.auto_create_statement_order_config.value)) {
                this.$message.error('是否自动生成对账单,每月号数只能填写1-31的正整数!');
                return;
            }
            if (this.systemSetting.auto_create_statement_order_config.value < 0 ||
                this.systemSetting.auto_create_statement_order_config.value > 31) {
                this.$message.error('是否自动生成对账单,每月号数只能填写1-31的正整数!');
                return;
            }
            this.systemSetting.auto_create_statement_order_config.value = Number(this.systemSetting.auto_create_statement_order_config.value);
        }
        var params = JSON.parse(JSON.stringify(this.systemSetting));
        params.business_data_power_status = this.systemSetting.business_data_power_status == true ? 1 : 0;
        params.depot_data_power_status = this.systemSetting.depot_data_power_status == true ? 1 : 0;
        params.permission_change_notify_status = this.systemSetting.permission_change_notify_status == true ? 1 : 0;
        params.delivery_is_goods_price_to_no_price =
            this.systemSetting.delivery_is_goods_price_to_no_price == true ? 1 : 2;
        params.delivery_is_auto_add_goods_price_to_no_price =
            this.systemSetting.delivery_is_auto_add_goods_price_to_no_price == true ? 1 : 2;
        params.auto_split_delivery_order_rule = {
            type: params.auto_split_delivery_order_rule_type,
            goods_type: params.auto_split_delivery_order_rule_goods_type,
            type_value: params.auto_split_delivery_order_rule_type_value,
        };
        delete params.supplier_version;
        this.service
            .saveSupplierConfig(params)
            .then(function (res) {
            if (res.data && res.data.success) {
                _this.$message.success(res.data.msg || '保存成功');
                _this.$store.commit(RootType.UPDATE_EDI_STATUS, _this.systemSetting.edi_status == 1 ? true : false);
                _this.$store.commit(RootType.UPDATE_CAN_SELECT_BATCH, _this.systemSetting.is_delivery_manual_batch);
                _this.$store.commit(RootType.UPDATE_CAN_SEND_EMAIL, _this.systemSetting.is_send_purchase_mail);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        })
            .catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    Index.prototype.setSpotPurchaseRule = function () {
        var _this = this;
        var _a = this.$dialog(DeliverySpotPurchaseRuleDialog, {}, {
            title: '现采货品应用规则',
            width: 1000,
            height: 600,
        }), instance = _a.instance, promise = _a.promise;
        promise.then(function (vm) {
            _this.systemSetting.upper_warehouse_order_rule_count = vm.total;
        });
    };
    Index.prototype.setSplitRule = function () {
        var instance = this.$dialog(DeliverySplitRuleDialog, {}, {
            title: '送货单拆分规则',
            width: 1000,
            height: 600,
        }).instance;
    };
    __decorate([
        Watch('systemSetting.delivery_is_goods_price_to_no_price')
    ], Index.prototype, "handleDeliverPriceOpen", null);
    Index = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
                openedCodeData: 'openedCodeData',
            })),
        })
    ], Index);
    return Index;
}(Vue));
export default Index;
